import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { userReducer } from "./reducers/user.reducer";
import { notificationsReducer } from "./reducers/notifications.reducer";
import { lessonsReducer } from "./reducers/lessons.reducer";
import { practitionersReducer } from "./reducers/practitioners.reducer";
import { paymentsReducer } from "./reducers/payments.reducer";
const rootPersistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  notifications: notificationsReducer,
  lessons: lessonsReducer,
  practitioners: practitionersReducer,
  payments: paymentsReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;

export const persistor = persistStore(store);
